export default `p.xz=mod(p.xz,2.)-1.;
    vec3 q=p;
    float s=2., e;
    for(int j=0;j++<8;)
      s*=e=2./clamp(dot(p,p),.5,1.),
      p=abs(p)*e-vec3(.5,8.0,.5);
    return max(q.y,length(p.xz)/s);
  }`